import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import HeaderForm from "./header_form";
import { ProductContext } from "../data/product_context_management";
import DescriptionForm from "./description_form";
import SpecificationsForm from "./specifications_form";

function EditModal() {
  const { product, openEditModal, setOpenEditModal } = useContext(ProductContext);
  const closeModal = () => {
    setOpenEditModal(null);
  };

  const modalTitle = (productName) => {
    switch (openEditModal) {
      case "HEADER":
        return `Editing ${productName}`;
      case "DESCRIPTION":
        return "Editing Description";
      case "SPECIFICATIONS":
        return "Editing Specifications";
      default:
        return null;
    }
  };

  return (
    <Modal show={!!openEditModal} onHide={closeModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle(product.name)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {openEditModal === "HEADER" && <HeaderForm />}
        {openEditModal === "DESCRIPTION" && <DescriptionForm />}
        {openEditModal === "SPECIFICATIONS" && <SpecificationsForm />}
      </Modal.Body>
    </Modal>
  );
}

export default EditModal;
